<!-- Overlay loading -->
<app-fullscreen-overlay [isOverlayLoading]="isOverlayLoading"></app-fullscreen-overlay>

<div class="conclusion-detail app-main flex-column flex-row-fluid" id="kt_app_main">
  <div class="d-flex flex-column flex-column-fluid">
    <div class="container-fluid container-flex">
      <div class="container-fluid">
        <div class="row">
          <!-- Patient Details -->
          <div class="col">
            <div class="container-fluid mt-1">
              <div class="card">
                <div class="accordion" id="accordionExample">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button id="myAccordionButton" class="accordion-button fw-medium fs-14 text-dark ps-4"
                        [ngClass]="patientCases?.length > 1 ? 'p-3 ps-4' : ''" type="button"
                        (mousemove)="handleMouseMove($event)" (mouseleave)="closeAccordion('collapseOne')"
                        aria-expanded="false" aria-controls="collapseOne">
                        <div class="patient-info">
                          <a [routerLink]="[
                              '/patient/details/',
                              patientHeaderInformations?.patientId,
                              patientRecordId,
                              consultationId
                            ]" class="text-black name-surname-field">
                            {{ patientHeaderInformations?.name || "-" }}
                            {{ patientHeaderInformations?.lastName || "-" }}</a>, {{ patientHeaderInformations?.age }},
                          {{ patientHeaderInformations?.gender[0] }},
                          <span class="badge badge-light-success ms-2">
                            {{ "dermNo" | translate }}:
                            {{ patientHeaderInformations?.pidNo || "-" }}
                          </span>
                        </div>

                        <div class="case-breadcrumb-container" (mouseenter)="mouseEnterInBreadcrumb($event)"
                          (mouseleave)="mouseLeaveInBreadcrumb($event)" *ngIf="patientCases?.length > 1">
                          <app-case-breadcrumb [cases]="patientCases" [(activeCase)]="activeCase"
                            (activeCaseChange)="activeCaseChange($event)"></app-case-breadcrumb>
                        </div>
                      </button>
                    </h2>
                    <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample">
                      <div class="accordion-body ps-4">
                        <!-- Skin Type & General Appearance -->
                        <div>
                          <span class="text-gray-800">
                            {{ skinTypeTextHeader() }}
                          </span>
                          <br />
                          <span class="text-gray-800">
                            {{ generalAppearanceTextHeader() }}</span>
                        </div>
                        <!-- Complaint & Duration & Change-->
                        <div class="border-start ps-4">
                          <span class="fw-bold">
                            {{ "complaint" | translate }}:
                          </span>
                          <span class="text-gray-800">
                            {{ complatintsTextHeader() || "none" | translate }}
                          </span>
                          <br />
                          <span class="fw-bold">
                            {{ "duration" | translate }}:
                          </span>
                          <span class="text-gray-800">
                            {{ durationTextHeader() || "none" | translate }}
                          </span>
                          <br />
                          <span class="fw-bold">
                            {{ "change" | translate }}:
                          </span>
                          <span class="text-gray-800">
                            {{ changeTextHeader() || "none" | translate }}
                          </span>
                        </div>
                        <!-- Medical History & Medications -->
                        <div class="border-start ps-4">
                          <div class="card-subtitle">
                            <span class="fw-bold">
                              {{ "medicalHistory" | translate }}:</span>
                            <span class="text-gray-800">
                              {{
                              medicalHistoryTextHeader() || "none" | translate
                              }}
                            </span>
                          </div>

                          <div class="card-subtitle mt-1">
                            <span class="fw-bold">
                              {{ "medications" | translate }}:</span>
                            <span class="text-gray-800">
                              {{
                              medicationsTextHeader() || "none" | translate
                              }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid flex-row-fluid">
        <div class="row h-100">
          <!-- Left Column -->
          <div class="col-12 col-lg-6 pe-lg-0">
            <div class="pt-2 pe-2 ps-3 pb-3 pb-lg-0 h-lg-100">
              <div class="card h-100">
                <button class="fullscreen-button">
                  <i class="fa-solid fa-expand"></i>
                </button>
                <div class="card-body p-0 container-flex">
                  <ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x m-0 fs-6 tab-padding-left">
                    <!-- Current case image tab -->
                    <li class="nav-item">
                      <a #leftFirstTab class="nav-link text-gray-800 active" data-bs-toggle="tab" href="#caseImage"
                        aria-selected="false" tabindex="-1" role="tab">{{ "currentCaseImage" | translate }}</a>
                    </li>
                    <!-- All current images tab -->
                    <li class="nav-item">
                      <a class="nav-link text-gray-800" data-bs-toggle="tab" href="#allCaseImages" aria-selected="false"
                        tabindex="-1" role="tab">
                        {{ "seeAllcurrentCaseImage" | translate }}
                      </a>
                    </li>
                  </ul>
                  <!-- Current case image tab content -->
                  <div id="myTabContent" [ngClass]="
                      activeTab === '#caseImage'
                        ? 'tab-content h-100'
                        : 'd-none'
                    ">
                    <div class="tab-pane fade show active h-100" id="caseImage" role="tabpanel">
                      <div class="row h-100">
                        <div class="col card-overflow overflow-hidden">
                          <div class="px-0 position-relative h-100">
                            <div class="row position-relative w-100 h-100">
                              <ng-container *ngIf="
                                  currentCaseData.src ||
                                    (patientRecordCaseImages?.length &&
                                      patientRecordCaseImages[0]?.src);
                                  else noImage
                                ">
                                <app-img-editor [src]="currentCaseData.src" [selectedDiagnosis]="selectedDiagnosis"
                                  [patientRecordCaseImageId]="
                                    currentCaseData.imageId
                                  " [caseDetailStatus]="
                                    patientHeaderInformations?.patientStatus
                                  " (annotationListChange)="
                                    annotationListChange($event)
                                  "></app-img-editor>
                                <div class="checkbox-container">
                                  <input class="form-check-input" type="checkbox" id="addReportCheckbox"
                                    [checked]="currentCaseData.isReportImage" (click)="
                                      selectImageForReport(
                                        currentCaseData,
                                        $event
                                      )
                                    " />
                                  <label for="addReportCheckbox">{{
                                    "addReport" | translate
                                    }}</label>
                                  <label *ngIf="currentCaseData.isSelected"
                                    class="badge badge-light-success ai-current-case-image" for="addReportCheckbox">{{
                                    "AI" | translate }}</label>
                                </div>
                                <div>
                                  <button (click)="prevImage()" class="arrow-button left">
                                    <i class="fa-solid fa-chevron-left"></i>
                                  </button>
                                  <button (click)="nextImage()" class="arrow-button right">
                                    <i class="fa-solid fa-chevron-right"></i>
                                  </button>
                                </div>
                              </ng-container>
                              <ng-template #noImage>
                                <!-- Skeleton while images are loading -->
                                <ng-container *ngIf="isImagesLoading; else noImageContent">
                                  <div class="image-skeleton-wrapper">
                                    <div class="image-skeleton shimmer"></div>
                                  </div>
                                </ng-container>
                                <!-- True no-image state -->
                                <ng-template #noImageContent>
                                  <div class="no-image-message text-start pt-2 ps-4">
                                    {{ "noImage" | translate }}
                                  </div>
                                </ng-template>
                              </ng-template>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- All current images content -->
                  <div class="tab-content" [ngClass]="
                      activeTab === '#allCaseImages'
                        ? 'tab-content h-100'
                        : 'd-none'
                    " id="myTabContent">
                    <div class="tab-panel fade all-case-images-tab" id="allCaseImages" role="tabpanel">
                      <div class="col card-overflow overflow-hidden">
                        <div class="p-3 px-0">
                          <button class="fullscreen-button">
                            <i class="fa-solid fa-expand"></i>
                          </button>

                          <!-- Skeleton grid while images are loading -->
                          <ng-container *ngIf="isImagesLoading">
                            <div class="row g-3 ps-4 width-100">
                              <div *ngFor="let _ of [1,2,3]"
                                class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4">
                                <div class="img-square skeleton-thumb shimmer"></div>
                              </div>
                            </div>
                          </ng-container>

                          <div class="row g-3 ps-4 width-100" *ngIf="!isImagesLoading">
                            <div *ngFor="
                                 let image of patientRecordCaseImages;
                                 let i = index
                               " class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4">
                              <a class="d-block" style="position: relative">
                                <div class="radio-button-container position-absolute">
                                  <input type="radio" [id]="'thumbnail-radio-' + i" [name]="'thumbnail-select'"
                                    [value]="image.id" class="form-check-input" [disabled]="isAllCasesCompleted()"
                                    (click)="selectImage(image)" />
                                  <label [for]="'thumbnail-radio-' + i"
                                    class="form-check-label visually-hidden"></label>
                                </div>
                                <div class="img-square">
                                  <img [src]="image.src" class="img-fluid rounded img-thumbnail border-0 p-0"
                                    [alt]="image.alt" [ngClass]="{
                                      'border-orange': image.isRightClicked
                                    }" style="width: 100%; object-fit: cover" (dblclick)="
                                      handleDoubleClickForCurrentImage(image)
                                    " />
                                  <span *ngIf="image.isSelected" class="badge badge-light-success ai-selected-image">{{
                                    "AI" | translate }}
                                  </span>
                                  <span *ngIf="image.isReportImage" class="badge badge-light-success reported-image">{{
                                    "reportedImage" | translate }}
                                  </span>
                                </div>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div *ngFor="
                          let image of patientRecordCaseImages;
                          let i = index
                        " class="modal fade" [id]="'image-modal-' + i" tabindex="-1" aria-labelledby="imageModalLabel"
                        aria-hidden="true" data-bs-backdrop="true" data-bs-keyboard="true">
                        <div class="modal-dialog modal-xl">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5 class="modal-title" id="imageModalLabel">
                                {{ "skinPreview" | translate }}
                              </h5>
                              <button type="button" class="btn-close" data-bs-dismiss="modal"
                                aria-label="Close"></button>
                            </div>
                            <div class="modal-body text-center pt-0">
                              <img [src]="image.src" id="modalImage" class="img-fluid" width="65%"
                                alt="Responsive image" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="container-fluid ai-analysis-button pb-3">
                        <div class="row">
                          <div class="col text-end">
                            <button type="button" class="btn btn-primary" data-bs-toggle="modal" [disabled]="
                                !hasAnySelectedImage || isAllCasesCompleted()
                              " (click)="sendReAnalysis()">
                              {{ "sendToAI" | translate }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Right Column -->
          <div class="col-12 col-lg-6 ps-lg-0">
            <div class="pt-2 pe-3 pb-3 h-lg-100">
              <div class="card h-100">
                <button class="fullscreen-button">
                  <i class="fa-solid fa-expand"></i>
                </button>
                <div class="card-body p-0 container-flex">
                  <ul *ngIf="setUserPermission()"
                    class="nav nav-tabs nav-line-tabs nav-line-tabs-2x m-1 fs-6 tab-padding-right mb-0" role="tablist">
                    <!-- Conclusion Tab -->
                    <li class="nav-item" role="presentation">
                      <a #rightFirstTab class="nav-link text-gray-800 active" data-bs-toggle="tab" href="#conclusion"
                        aria-selected="true" role="tab">{{ "conclusion" | translate }}</a>
                    </li>
                    <!-- AI Report Tab -->
                    <li class="nav-item" role="presentation">
                      <a (click)="selectTab('aiReport')" class="nav-link text-gray-800" data-bs-toggle="tab"
                        href="#aiReport" aria-selected="false" role="tab">{{ "aiReport" | translate }}</a>
                    </li>
                    <!-- Case History Tab -->
                    <li class="nav-item" role="presentation">
                      <a (click)="selectTab('caseHistory')" class="nav-link text-gray-800" data-bs-toggle="tab"
                        href="#caseHistory" aria-selected="false" tabindex="-1" role="tab">{{ "patientHistory" |
                        translate }}</a>
                    </li>
                    <!-- Chat with GP Tab -->
                    <li class="nav-item" role="presentation">
                      <a (click)="selectTab('chatWithGp')" class="nav-link text-gray-800" data-bs-toggle="tab"
                        href="#chatWithGp" aria-selected="true" role="tab">{{ "chatWithGP" | translate }}</a>
                    </li>
                  </ul>
                  <!-- Conclusions for Dermatologist -->
                  <div *ngIf="setUserPermission()" class="tab-content pb-0 pt-0 h-100 container-flex" id="myTabContent">
                    <!-- Conclusion Content -->
                    <div id="conclusion" role="tabpanel" [ngClass]="
                        activeRightTab === '#conclusion'
                          ? 'tab-pane fade active show px-4 pt-2 h-100 container-flex'
                          : 'd-none'
                      ">
                      <div class="col container-flex">
                        <div class="container px-0">
                          <!-- Diagnosis Dropdown -->
                          <div class="row">
                            <!-- Main Dropdown -->
                            <div class="col-md-6 pe-2">
                              <select class="form-select" [(ngModel)]="selectedDiagnosis" (change)="onDiagnosisChange()"
                                [disabled]="isAllCasesCompleted()">
                                <option value="" disabled>
                                  {{ "selectDiagnosis" | translate }}
                                </option>
                                <option *ngFor="let diagnosis of diagnoses" [value]="diagnosis.id">
                                  {{ diagnosis.name }}
                                </option>
                              </select>
                            </div>
                            <div class="col-md-6 ps-2">
                              <!-- Benign Skin Conditions Subcategories -->
                              <ng-container *ngIf="
                                  selectedDiagnosis === benignSkinConditions
                                ">
                                <select id="subcategories" class="form-select" [(ngModel)]="selectedSubcategory"
                                  (change)="onSubcategoryChange('benign')" [disabled]="isAllCasesCompleted()">
                                  <option value="" disabled>
                                    {{ "selectSubcategory" | translate }}
                                  </option>
                                  <option *ngFor="
                                      let subcategory of benignSubcategories
                                    " [value]="subcategory.id">
                                    {{ subcategory.name }}
                                  </option>
                                </select>
                              </ng-container>

                              <!-- Pre-Malignant & Malignant Skin Conditions Subcategories -->
                              <ng-container *ngIf="
                                  selectedDiagnosis ===
                                  preMalignantSkinConditions
                                ">
                                <select id="subcategories" class="form-select" [(ngModel)]="selectedSubcategory"
                                  (change)="onSubcategoryChange('preMalignant')" [disabled]="isAllCasesCompleted()">
                                  <option value="" disabled>
                                    {{ "selectSubcategory" | translate }}
                                  </option>
                                  <option *ngFor="
                                      let subcategory of preMalignantSubcategories
                                    " [value]="subcategory.id">
                                    {{ subcategory.name }}
                                  </option>
                                </select>
                              </ng-container>

                              <!-- Malignant Melanoma -->
                              <ng-container *ngIf="
                                  selectedDiagnosis === malignantSkinConditions
                                ">
                                <select id="subcategories" class="form-select" [(ngModel)]="selectedSubcategory"
                                  (change)="onSubcategoryChange('malignant')" [disabled]="isAllCasesCompleted()">
                                  <option value="" disabled>
                                    {{ "selectSubcategory" | translate }}
                                  </option>
                                  <option *ngFor="
                                      let subcategory of malignantSubcategories
                                    " [value]="subcategory.id">
                                    {{ subcategory.name }}
                                  </option>
                                </select>
                              </ng-container>
                            </div>
                          </div>

                          <!-- Conclusion Dropdowns -->
                          <ng-container *ngIf="
                              selectedDiagnosis === malignantSkinConditions
                            ">
                            <div class="row g-4 mt-0">
                              <div *ngFor="
                                  let option of conclusionOptions;
                                  let i = index
                                " class="col-md-6">
                                <select id="part{{ i }}" class="form-select" aria-label="Pre defined conclusion inputs"
                                  [disabled]="
                                    isSelectDisable(option) ||
                                    isAllCasesCompleted() ||
                                    (option.id === RECOMMENDATION_OPTION_ID && isRecommendationDisabled)
                                  " (change)="updateConclusionOutput($event)">
                                  <option [hidden]="true">
                                    {{ option?.title }}
                                  </option>
                                  <option value="" disabled>
                                    {{ "selectAnAnnotation" | translate }}
                                  </option>
                                  <option *ngFor="
                                      let optionItem of option.conclusionOptionContents
                                    " [value]="optionItem.id" [selected]="
                                      isSelectedOption(
                                        optionItem.conclusionText
                                      ) || isSelectedAdvancedExamination()
                                    ">
                                    {{ optionItem.title }}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                        <div class="text-inverse-light p-6 px-0 pb-0 container-flex">
                          <textarea rows="13" class="form-control conclusion-text-area"
                            [(ngModel)]="selectedConclusionText" [readonly]="true" [placeholder]="
                              ('conclusionFor' | translate) +
                              ' ' +
                              (patientHeaderInformations?.name || '-') +
                              ' ' +
                              (patientHeaderInformations?.lastName || '-')
                            "></textarea>
                        </div>
                      </div>

                      <div class="d-grid gap-2 pb-3 pt-3">
                        <div class="row">
                          <div class="col text-end button-area" *ngIf="
                              patientCases?.length &&
                              consultationId ===
                                patientCases[patientCases.length - 1]
                                  .patientRecordCaseId
                            ">
                            <div *ngIf="
                                isSubmitButtonDisable() && showDisableButtonDesc
                              ">
                              <span>
                                *{{
                                "consultationRequiredText" | translate
                                }}</span>
                            </div>
                            <div class="buttons">
                              <button type="button" class="btn btn-primary mx-3" data-bs-toggle="modal"
                                [attr.data-bs-target]="
                                  '#previewFinalReportModal'
                                " (click)="previewReport()" [disabled]="isPreviewButtonDisable()">
                                {{ "previewFinalReport" | translate }}
                              </button>
                              <button *ngIf="
                                  isAdvancedExaminaitonSelected();
                                  else notSendToGP
                                " type="button" (click)="sendReport()" class="btn btn-dark" [ngClass]="{
                                  'w-135': lang() === 'en',
                                  'w-180': lang() === 'nl'
                                }" [disabled]="isSubmitButtonDisable()">
                                {{ "sendToGP" | translate }}
                              </button>
                              <ng-template #notSendToGP>
                                <button type="button" data-bs-toggle="modal"
                                  data-bs-target="#conclusionMailTemplateModal"
                                  (click)="getConsultationMailTemplateAsync()" class="btn btn-dark" [ngClass]="{
                                    'w-135': lang() === 'en',
                                    'w-180': lang() === 'nl'
                                  }" [disabled]="isSubmitButtonDisable()">
                                  {{
                                  isAllCasesCompleted() && !isComeFromReferral
                                  ? ("sendReportAgain" | translate)
                                  : ("sendReport" | translate)
                                  }}
                                </button>
                              </ng-template>
                            </div>
                          </div>
                          <div class="col text-end button-area" *ngIf="
                              patientCases?.length &&
                              consultationId !==
                                patientCases[patientCases.length - 1]
                                  .patientRecordCaseId
                            ">
                            <div *ngIf="
                                isSubmitButtonDisable() && showDisableButtonDesc
                              ">
                              <span>
                                *{{
                                "consultationRequiredText" | translate
                                }}</span>
                            </div>
                            <button *ngIf="!isAllCasesCompleted()" type="button" (click)="saveCaseAndNext()"
                              class="btn btn-dark ms-3" [disabled]="isSubmitButtonDisable()">
                              {{ "saveAndNext" | translate }}
                            </button>
                            <button *ngIf="isAllCasesCompleted()" type="button" (click)="goToNextCase()"
                              class="btn btn-dark ms-3" [disabled]="isSubmitButtonDisable()">
                              {{ "next" | translate }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- AI Report Content -->
                    <div id="aiReport" role="tabpanel" [ngClass]="
                        activeRightTab === '#aiReport'
                          ? 'tab-pane fade active show h-100'
                          : 'd-none'
                      ">
                      <!-- Loading state -->
                      <ng-container *ngIf="isAiLoading">
                        <div
                          class="ai-report-placeholder d-flex flex-column align-items-center justify-content-center h-100 gap-3 text-muted">
                          <div class="spinner-border text-primary" role="status" style="width:2.5rem;height:2.5rem;">
                            <span class="visually-hidden">Loading...</span>
                          </div>
                          <span>{{ "aiReportLoading" | translate }}</span>
                        </div>
                      </ng-container>
                      <!-- No analysis state -->
                      <ng-container *ngIf="!isAiLoading && !aiImages?.allImagesExist">
                        <div
                          class="ai-report-placeholder d-flex flex-column align-items-center justify-content-center h-100 gap-2 text-muted">
                          <i class="fa-solid fa-robot fa-2x opacity-50"></i>
                          <span>{{ "noAiReport" | translate }}</span>
                        </div>
                      </ng-container>
                      <!-- Actual AI content -->
                      <div class=" ai-tab-content px-4"
                        *ngIf="!isAiLoading && showImageGalleryAi && !fullscreenImageAi && aiImages?.allImagesExist">
                        <div class="chart-area">
                          <app-gauge-chart [gaugeRate]="aiImages.gaugeRate"></app-gauge-chart>
                        </div>

                        <!-- Split View Container -->
                        <div class="ai-report-container">
                          <!-- Left Column: Navigation Sidebar -->
                          <div class="ai-nav-sidebar">
                            <button type="button" class="ai-nav-item ai-nav-tds"
                              [ngClass]="{ 'active': selectedAIReportSection === 'tdsScoring' }"
                              (click)="selectAIReportSection('tdsScoring')" [title]="'tdsScoring' | translate">
                              TDS
                            </button>
                            <button type="button" class="ai-nav-item ai-nav-a"
                              [ngClass]="{ 'active': selectedAIReportSection === 'asymmetry' }"
                              (click)="selectAIReportSection('asymmetry')" [title]="'asymmetry' | translate">
                              A
                            </button>
                            <button type="button" class="ai-nav-item ai-nav-b"
                              [ngClass]="{ 'active': selectedAIReportSection === 'borderIrregularity' }"
                              (click)="selectAIReportSection('borderIrregularity')"
                              [title]="'borderIrregularity' | translate">
                              B
                            </button>
                            <button type="button" class="ai-nav-item ai-nav-c"
                              [ngClass]="{ 'active': selectedAIReportSection === 'color' }"
                              (click)="selectAIReportSection('color')" [title]="'color' | translate">
                              C
                            </button>
                            <button type="button" class="ai-nav-item ai-nav-d"
                              [ngClass]="{ 'active': selectedAIReportSection === 'diameter' }"
                              (click)="selectAIReportSection('diameter')" [title]="'diameter' | translate">
                              D
                            </button>

                            <!-- DEV-only: lesionSpaceImage hover preview -->
                            <div *ngIf="isDebugDomain && aiImages?.lesionSpaceImage" class="debug-lesion-wrapper">
                              <button type="button" class="debug-lesion-btn" title="lesionSpaceImage">
                                <i class="fa-solid fa-bug"></i>
                              </button>
                              <div class="debug-lesion-popup">
                                <p class="debug-lesion-label">lesionSpaceImage</p>
                                <img [src]="aiImages.lesionSpaceImage" alt="lesionSpaceImage debug" />
                              </div>
                            </div>

                          </div>

                          <!-- Right Column: Content Card -->
                          <div class="ai-content-card" [ngClass]="'section-' + selectedAIReportSection">
                            <ng-container [ngSwitch]="selectedAIReportSection">
                              <!-- TDS Scoring Section -->
                              <div *ngSwitchCase="'tdsScoring'">
                                <h5>
                                  <i class="fa-solid fa-calculator me-1" style="color: #7c3aed"></i>
                                  {{ "tdsScoring" | translate }}
                                </h5>

                                <!-- TDS Score Display -->
                                <div class="tds-main-score mb-3" *ngIf="skinAnalysisMetrics?.analysis">
                                  <div class="score-card p-4 rounded-3 mb-3 text-white position-relative"
                                    style="background: linear-gradient(135deg, #7c3aed 0%, #5b21b6 100%); box-shadow: 0 4px 15px rgba(124, 58, 237, 0.3);">
                                    <div class="d-flex justify-content-between align-items-center">
                                      <div>
                                        <span class="d-block opacity-75 small mb-1">{{ 'aiTab.totalScore' | translate
                                          }}</span>
                                        <h2 class="display-5 fw-bold mb-0">{{ skinAnalysisMetrics.tdsScore |
                                          number:'1.0-0' }}</h2>
                                      </div>
                                      <div class="text-end">
                                        <i class="fa-solid fa-calculator fa-2x opacity-50"></i>
                                      </div>
                                    </div>
                                  </div>

                                </div>

                                <!-- A, B, C, D Scores -->
                                <div class="tds-scores">
                                  <h6 class="mb-2 small">{{ 'aiTab.abcdeScores' | translate }}:</h6>
                                  <div class="tds-scores-grid">
                                    <div class="tds-score-item">
                                      <span class="text-muted">A — {{ "asymmetry" | translate }}</span>
                                      <span class="fw-bold">{{ skinAnalysisMetrics?.analysis?.abcdeScores?.asymmetry ??
                                        '-' | number:'1.0-0' }}</span>
                                    </div>
                                    <div class="tds-score-item">
                                      <span class="text-muted">B — {{ "borderIrregularity" | translate }}</span>
                                      <span class="fw-bold">{{ skinAnalysisMetrics?.analysis?.abcdeScores?.border ?? '-'
                                        | number:'1.0-0' }}</span>
                                    </div>
                                    <div class="tds-score-item">
                                      <span class="text-muted">C — {{ "color" | translate }}</span>
                                      <span class="fw-bold">{{ skinAnalysisMetrics?.analysis?.abcdeScores?.color ?? '-'
                                        | number:'1.0-0' }}</span>
                                    </div>
                                    <div class="tds-score-item">
                                      <span class="text-muted">D — {{ "diameter" | translate }}</span>
                                      <span class="fw-bold">{{ skinAnalysisMetrics?.analysis?.abcdeScores?.diameter ??
                                        '-' | number:'1.0-0' }}</span>
                                    </div>
                                  </div>
                                </div>



                                <!-- No Data Message -->
                                <div *ngIf="!skinAnalysisMetrics?.analysis" class="text-muted">
                                  <i class="fa-solid fa-info-circle me-2"></i>
                                  {{ 'aiTab.noSkinAnalysisMetrics' | translate }}
                                </div>
                              </div>

                              <!-- A - Asymmetry Section -->
                              <div *ngSwitchCase="'asymmetry'" class="h-100 d-flex flex-column">
                                <h5 class="mb-4">
                                  <i class="fa-solid fa-shapes me-2" style="color: #667eea"></i>
                                  {{ "asymmetry" | translate }}
                                </h5>

                                <div class="row g-4" *ngIf="skinAnalysisMetrics?.analysis?.metrics?.asymmetry">
                                  <!-- Left Col: Chart -->
                                  <div class="col-12 col-md-12 col-lg-7 col-xl-8 d-flex flex-column">
                                    <div class="card shadow-sm border-0 bg-light">
                                      <div class="card-body d-flex align-items-center justify-content-center">
                                        <div class="chart-container w-100">
                                          <canvas id="asymmetryChart"></canvas>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <!-- Right Col: Fancy Metrics -->
                                  <div class="col-12 col-md-12 col-lg-5 col-xl-4">
                                    <div class="card shadow-sm border-0">
                                      <div class="card-body">
                                        <!-- Main Score -->
                                        <div class="score-card p-4 rounded-3 mb-4 text-white position-relative"
                                          style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); box-shadow: 0 4px 15px rgba(118, 75, 162, 0.3);">
                                          <div class="d-flex justify-content-between align-items-center">
                                            <div>
                                              <span class="d-block opacity-75 small mb-1">{{ 'aiTab.totalScore' |
                                                translate }}</span>
                                              <h2 class="display-5 fw-bold mb-0">
                                                {{ skinAnalysisMetrics.analysis.abcdeScores?.asymmetry | number:'1.0-0'
                                                }}
                                              </h2>
                                            </div>
                                            <div class="text-end">
                                              <i class="fa-solid fa-chart-pie fa-2x opacity-50"></i>
                                            </div>
                                          </div>
                                        </div>

                                        <!-- Detailed Metrics List -->
                                        <div class="vstack gap-3">
                                          <!-- Assessment -->
                                          <div
                                            class="d-flex align-items-center p-3 rounded bg-light border-start border-4 border-info">
                                            <div class="me-3">
                                              <div
                                                class="icon-circle bg-white text-info rounded-circle shadow-sm d-flex align-items-center justify-content-center"
                                                style="width: 40px; height: 40px;">
                                                <i class="fa-solid fa-magnifying-glass"></i>
                                              </div>
                                            </div>
                                            <div>
                                              <small class="text-muted d-block line-height-1">{{ 'aiTab.assessment' |
                                                translate }}</small>
                                              <span class="fw-bold text-dark">
                                                {{ skinAnalysisMetrics.analysis.metrics.asymmetry.assessment || 'N/A' }}
                                              </span>
                                            </div>
                                          </div>

                                          <!-- Mean Score -->
                                          <div
                                            class="d-flex align-items-center p-3 rounded bg-light border-start border-4 border-primary">
                                            <div class="me-3">
                                              <div
                                                class="icon-circle bg-white text-primary rounded-circle shadow-sm d-flex align-items-center justify-content-center"
                                                style="width: 40px; height: 40px;">
                                                <i class="fa-solid fa-calculator"></i>
                                              </div>
                                            </div>
                                            <div>
                                              <small class="text-muted d-block line-height-1">{{ 'aiTab.meanScore' |
                                                translate }}</small>
                                              <span class="fw-bold text-dark">
                                                {{ skinAnalysisMetrics.analysis.metrics.asymmetry.meanScore |
                                                number:'1.2-2' }}
                                              </span>
                                            </div>
                                          </div>

                                          <!-- Best Axis -->
                                          <div
                                            class="d-flex align-items-center p-3 rounded bg-light border-start border-4 border-success">
                                            <div class="me-3">
                                              <div
                                                class="icon-circle bg-white text-success rounded-circle shadow-sm d-flex align-items-center justify-content-center"
                                                style="width: 40px; height: 40px;">
                                                <i class="fa-solid fa-arrows-rotate"></i>
                                              </div>
                                            </div>
                                            <div>
                                              <small class="text-muted d-block line-height-1">{{ 'aiTab.bestAxis' |
                                                translate }}</small>
                                              <div class="d-flex align-items-baseline gap-2">
                                                <span class="fw-bold text-dark fs-5">{{
                                                  skinAnalysisMetrics.analysis.metrics.asymmetry.bestAxisAngle
                                                  }}°</span>
                                                <span class="text-muted small">
                                                  (Score: {{
                                                  skinAnalysisMetrics.analysis.metrics.asymmetry.bestAxisScore |
                                                  number:'1.2-2' }})
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <!-- Footer Info -->
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div *ngIf="!skinAnalysisMetrics?.analysis?.metrics?.asymmetry"
                                  class="alert alert-warning mt-3">
                                  {{ 'aiTab.metricsNotAvailable' | translate }}
                                </div>
                              </div>

                              <!-- B - Border Irregularity Section -->
                              <div *ngSwitchCase="'borderIrregularity'" class="h-100 d-flex flex-column"
                                style="padding-bottom: 2px;">
                                <h5 class="mb-4">
                                  <i class="fa-solid fa-vector-square me-2" style="color: #FF6B6B"></i>
                                  {{ "borderIrregularity" | translate }}
                                </h5>

                                <div class="row g-4" *ngIf="skinAnalysisMetrics?.analysis?.metrics?.border">
                                  <!-- Left Col: Chart -->
                                  <div class="col-12 col-md-12 col-lg-7 col-xl-8 d-flex flex-column">
                                    <div class="card shadow-sm border-0 bg-light">
                                      <div class="card-body d-flex align-items-center justify-content-center">
                                        <div class="chart-container w-100">
                                          <canvas id="borderChart"></canvas>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <!-- Right Col: Fancy Metrics -->
                                  <div class="col-12 col-md-12 col-lg-5 col-xl-4">
                                    <div class="card shadow-sm border-0">
                                      <div class="card-body">
                                        <!-- Main Score -->
                                        <div class="score-card p-4 rounded-3 mb-4 text-white position-relative"
                                          style="background: linear-gradient(135deg, #FF6B6B 0%, #FF8E53 100%); box-shadow: 0 4px 15px rgba(255, 107, 107, 0.3);">
                                          <div class="d-flex justify-content-between align-items-center">
                                            <div>
                                              <span class="d-block opacity-75 small mb-1">{{ 'aiTab.totalScore' |
                                                translate }}</span>
                                              <h2 class="display-5 fw-bold mb-0">
                                                {{ skinAnalysisMetrics.analysis.abcdeScores?.border | number:'1.0-0' }}
                                              </h2>
                                            </div>
                                            <div class="text-end">
                                              <i class="fa-solid fa-chart-area fa-2x opacity-50"></i>
                                            </div>
                                          </div>
                                        </div>

                                        <!-- Detailed Metrics List -->
                                        <div class="vstack gap-3">
                                          <!-- Total Metric -->
                                          <div
                                            class="d-flex align-items-center p-3 rounded bg-light border-start border-4 border-danger">
                                            <div class="me-3">
                                              <div
                                                class="icon-circle bg-white text-danger rounded-circle shadow-sm d-flex align-items-center justify-content-center"
                                                style="width: 40px; height: 40px;">
                                                <i class="fa-solid fa-calculator"></i>
                                              </div>
                                            </div>
                                            <div>
                                              <small class="text-muted d-block line-height-1">{{
                                                'aiTab.totalBorderScore' | translate }}</small>
                                              <span class="fw-bold text-dark">
                                                {{ skinAnalysisMetrics.analysis.metrics.border.totalScore |
                                                number:'1.2-2' }}
                                              </span>
                                            </div>
                                          </div>

                                          <!-- Irregular Segments -->
                                          <div
                                            class="d-flex align-items-center p-3 rounded bg-light border-start border-4 border-warning">
                                            <div class="me-3">
                                              <div
                                                class="icon-circle bg-white text-warning rounded-circle shadow-sm d-flex align-items-center justify-content-center"
                                                style="width: 40px; height: 40px;">
                                                <i class="fa-solid fa-puzzle-piece"></i>
                                              </div>
                                            </div>
                                            <div class="flex-grow-1">
                                              <small class="text-muted d-block line-height-1 mb-1">{{
                                                'aiTab.irregularSegments' | translate }}</small>
                                              <div class="d-flex align-items-center">
                                                <span class="fw-bold text-dark me-2">
                                                  {{ skinAnalysisMetrics.analysis.metrics.border.irregularSegments }} /
                                                  8
                                                </span>
                                                <div class="progress flex-grow-1" style="height: 6px;">
                                                  <div class="progress-bar bg-warning" role="progressbar"
                                                    [style.width.%]="(skinAnalysisMetrics.analysis.metrics.border.irregularSegments / 8) * 100">
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <!-- Footer Info -->
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div *ngIf="!skinAnalysisMetrics?.analysis?.metrics?.border"
                                  class="alert alert-warning mt-3">
                                  {{ 'aiTab.metricsNotAvailable' | translate }}
                                </div>
                              </div>

                              <!-- C - Color Section -->
                              <div *ngSwitchCase="'color'" class="h-100 d-flex flex-column">
                                <h5 class="mb-4">
                                  <i class="fa-solid fa-palette me-2" style="color: #11998e"></i>
                                  {{ "color" | translate }}
                                </h5>

                                <div class="row g-4" *ngIf="skinAnalysisMetrics?.analysis?.metrics?.color">
                                  <!-- Left Col: Chart -->
                                  <div class="col-12 col-md-12 col-lg-7 col-xl-8 d-flex flex-column">
                                    <div class="card shadow-sm border-0 bg-light">
                                      <div class="card-body d-flex align-items-center justify-content-center">
                                        <div class="chart-container w-100">
                                          <canvas id="colorChart"></canvas>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <!-- Right Col: Fancy Metrics -->
                                  <div class="col-12 col-md-12 col-lg-5 col-xl-4">
                                    <div class="card shadow-sm border-0">
                                      <div class="card-body">
                                        <!-- Main Score -->
                                        <div class="score-card p-4 rounded-3 mb-4 text-white position-relative"
                                          style="background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%); box-shadow: 0 4px 15px rgba(56, 239, 125, 0.3);">
                                          <div class="d-flex justify-content-between align-items-center">
                                            <div>
                                              <span class="d-block opacity-75 small mb-1">{{ 'aiTab.totalScore' |
                                                translate }}</span>
                                              <h2 class="display-5 fw-bold mb-0">
                                                {{ skinAnalysisMetrics.analysis.abcdeScores?.color | number:'1.0-0' }}
                                              </h2>
                                            </div>
                                            <div class="text-end">
                                              <i class="fa-solid fa-palette fa-2x opacity-50"></i>
                                            </div>
                                          </div>
                                        </div>

                                        <!-- Detailed Metrics List -->
                                        <div class="vstack gap-3">
                                          <!-- Colors Count -->
                                          <div
                                            class="d-flex align-items-center p-3 rounded bg-light border-start border-4 border-success">
                                            <div class="me-3">
                                              <div
                                                class="icon-circle bg-white text-success rounded-circle shadow-sm d-flex align-items-center justify-content-center"
                                                style="width: 40px; height: 40px;">
                                                <i class="fa-solid fa-layer-group"></i>
                                              </div>
                                            </div>
                                            <div>
                                              <small class="text-muted d-block line-height-1">{{
                                                'aiTab.detectedColorsCount' | translate }}</small>
                                              <span class="fw-bold text-dark fs-5">
                                                {{ skinAnalysisMetrics.analysis.metrics.color.colorsCount }}
                                              </span>
                                            </div>
                                          </div>

                                          <!-- Detected Colors List -->
                                          <div class="p-3 rounded bg-light border-start border-4 border-primary">
                                            <small class="text-muted d-block line-height-1 mb-2">{{
                                              'aiTab.detectedColors' | translate }}</small>
                                            <div class="d-flex flex-wrap gap-2"
                                              *ngIf="skinAnalysisMetrics.analysis.abcdeScores?.colorsDetected?.length; else noColors">
                                              <span
                                                *ngFor="let color of skinAnalysisMetrics.analysis.abcdeScores.colorsDetected"
                                                class="badge bg-white text-dark shadow-sm border d-flex align-items-center px-3 py-2">
                                                <i class="fa-solid fa-circle me-2"
                                                  [ngStyle]="{'color': color?.toLowerCase() === 'white' ? '#eee' : color?.toLowerCase() }"></i>
                                                {{ color }}
                                              </span>
                                            </div>
                                            <ng-template #noColors>
                                              <span class="text-muted small fst-italic">{{ 'aiTab.noColorsDetected' |
                                                translate }}</span>
                                            </ng-template>
                                          </div>
                                        </div>

                                        <!-- Footer Info -->
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div *ngIf="!skinAnalysisMetrics?.analysis?.metrics?.color"
                                  class="alert alert-warning mt-3">
                                  {{ 'aiTab.metricsNotAvailable' | translate }}
                                </div>
                              </div>

                              <!-- D - Diameter Section -->
                              <div *ngSwitchCase="'diameter'" class="h-100 d-flex flex-column">
                                <h5 class="mb-4">
                                  <i class="fa-solid fa-ruler-horizontal me-2" style="color: #FF9966"></i>
                                  {{ "diameter" | translate }}
                                </h5>

                                <div class="row g-4" *ngIf="skinAnalysisMetrics?.analysis?.metrics?.diameter">
                                  <!-- Left Col: Chart -->
                                  <div class="col-12 col-md-12 col-lg-7 col-xl-8 d-flex flex-column">
                                    <div class="card shadow-sm border-0 bg-light">
                                      <div class="card-body d-flex align-items-center justify-content-center">
                                        <div class="chart-container w-100">
                                          <canvas id="diameterChart"></canvas>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <!-- Right Col: Fancy Metrics -->
                                  <div class="col-12 col-md-12 col-lg-5 col-xl-4">
                                    <div class="card shadow-sm border-0">
                                      <div class="card-body">
                                        <!-- Main Score -->
                                        <div class="score-card p-4 rounded-3 mb-4 text-white position-relative"
                                          style="background: linear-gradient(135deg, #FF9966 0%, #FF5E62 100%); box-shadow: 0 4px 15px rgba(255, 94, 98, 0.3);">
                                          <div class="d-flex justify-content-between align-items-center">
                                            <div>
                                              <span class="d-block opacity-75 small mb-1">{{ 'aiTab.totalScore' |
                                                translate }}</span>
                                              <h2 class="display-5 fw-bold mb-0">
                                                {{ skinAnalysisMetrics.analysis.abcdeScores?.diameter | number:'1.0-0'
                                                }}
                                              </h2>
                                            </div>
                                            <div class="text-end">
                                              <i class="fa-solid fa-maximize fa-2x opacity-50"></i>
                                            </div>
                                          </div>
                                        </div>

                                        <!-- Detailed Metrics List -->
                                        <div class="vstack gap-3">
                                          <!-- Major Axis -->
                                          <div
                                            class="d-flex align-items-center p-3 rounded bg-light border-start border-4 border-primary">
                                            <div class="me-3">
                                              <div
                                                class="icon-circle bg-white text-primary rounded-circle shadow-sm d-flex align-items-center justify-content-center"
                                                style="width: 40px; height: 40px;">
                                                <i class="fa-solid fa-arrows-left-right"></i>
                                              </div>
                                            </div>
                                            <div>
                                              <small class="text-muted d-block line-height-1">{{ 'aiTab.majorAxis' |
                                                translate }}</small>
                                              <span class="fw-bold text-dark fs-5">
                                                {{ (skinAnalysisMetrics.analysis.metrics.diameter.majorAxisMm ??
                                                skinAnalysisMetrics.analysis.metrics.diameter.majorAxisPx) |
                                                number:'1.2-2' }}
                                                <span class="fs-6 text-muted">mm</span>
                                              </span>
                                            </div>
                                          </div>

                                          <!-- Minor Axis -->
                                          <div
                                            class="d-flex align-items-center p-3 rounded bg-light border-start border-4 border-info">
                                            <div class="me-3">
                                              <div
                                                class="icon-circle bg-white text-info rounded-circle shadow-sm d-flex align-items-center justify-content-center"
                                                style="width: 40px; height: 40px;">
                                                <i class="fa-solid fa-arrows-up-down"></i>
                                              </div>
                                            </div>
                                            <div>
                                              <small class="text-muted d-block line-height-1">{{ 'aiTab.minorAxis' |
                                                translate }}</small>
                                              <span class="fw-bold text-dark fs-5">
                                                {{ (skinAnalysisMetrics.analysis.metrics.diameter.minorAxisMm ??
                                                skinAnalysisMetrics.analysis.metrics.diameter.minorAxisPx) |
                                                number:'1.2-2' }}
                                                <span class="fs-6 text-muted">mm</span>
                                              </span>
                                            </div>
                                          </div>

                                          <!-- Area -->
                                          <div
                                            class="d-flex align-items-center p-3 rounded bg-light border-start border-4 border-success">
                                            <div class="me-3">
                                              <div
                                                class="icon-circle bg-white text-success rounded-circle shadow-sm d-flex align-items-center justify-content-center"
                                                style="width: 40px; height: 40px;">
                                                <i class="fa-solid fa-vector-square"></i>
                                              </div>
                                            </div>
                                            <div>
                                              <small class="text-muted d-block line-height-1">{{ 'aiTab.area' |
                                                translate }}</small>
                                              <span class="fw-bold text-dark fs-5">
                                                {{ (skinAnalysisMetrics.analysis.metrics.diameter.areaMm2 ??
                                                skinAnalysisMetrics.analysis.metrics.diameter.areaPx) |
                                                number:'1.2-2' }}
                                                <span class="fs-6 text-muted">mm²</span>
                                              </span>
                                            </div>
                                          </div>

                                          <!-- Aspect Ratio -->
                                          <div
                                            class="d-flex align-items-center p-3 rounded bg-light border-start border-4 border-warning">
                                            <div class="me-3">
                                              <div
                                                class="icon-circle bg-white text-warning rounded-circle shadow-sm d-flex align-items-center justify-content-center"
                                                style="width: 40px; height: 40px;">
                                                <i class="fa-solid fa-arrows-up-down-left-right"></i>
                                              </div>
                                            </div>
                                            <div>
                                              <small class="text-muted d-block line-height-1">{{ 'aiTab.aspectRatio' |
                                                translate }}</small>
                                              <span class="fw-bold text-dark fs-5">
                                                {{ skinAnalysisMetrics.analysis.metrics.diameter.aspectRatio |
                                                number:'1.2-2' }}
                                              </span>
                                            </div>
                                          </div>
                                        </div>

                                        <!-- Footer Info -->
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div *ngIf="!skinAnalysisMetrics?.analysis?.metrics?.diameter"
                                  class="alert alert-warning mt-3">
                                  {{ 'aiTab.diameterAnalysisNotAvailable' | translate }}
                                </div>
                              </div>
                            </ng-container>
                          </div>
                        </div>

                        <div class="cbir-analysis-area">
                          <span class="image-header">
                            <i class="fa-solid fa-magnifying-glass-chart me-2 text-warning"></i>
                            {{ "cbirAnalysis" | translate }}
                          </span>
                          <div class="cbir-images">
                            <div class="cbir-item">
                              <span>{{ aiImages.cbir1Value }}</span>
                              <img [src]="
                                  aiImages.cbir1Image ||
                                  '/assets/media/not-found.jpeg'
                                " (error)="onImageError($event)" (dblclick)="
                                  showAiImagesFullscreen(aiImages.cbir1Image)
                                " />
                            </div>
                            <div class="cbir-item">
                              <span>{{ aiImages.cbir2Value }}</span>
                              <img [src]="
                                  aiImages.cbir2Image ||
                                  '/assets/media/not-found.jpeg'
                                " (error)="onImageError($event)" (dblclick)="
                                  showAiImagesFullscreen(aiImages.cbir2Image)
                                " />
                            </div>
                            <div class="cbir-item">
                              <span>{{ aiImages.cbir3Value }}</span>
                              <img [src]="
                                  aiImages.cbir3Image ||
                                  '/assets/media/not-found.jpeg'
                                " (error)="onImageError($event)" (dblclick)="
                                  showAiImagesFullscreen(aiImages.cbir3Image)
                                " />
                            </div>
                            <div class="cbir-item">
                              <span>{{ aiImages.cbir4Value }}</span>
                              <img [src]="
                                  aiImages.cbir4Image ||
                                  '/assets/media/not-found.jpeg'
                                " (error)="onImageError($event)" (dblclick)="
                                  showAiImagesFullscreen(aiImages.cbir4Image)
                                " />
                            </div>
                            <div class="cbir-item">
                              <span>{{ aiImages.cbir5Value }}</span>
                              <img [src]="
                                  aiImages.cbir5Image ||
                                  '/assets/media/not-found.jpeg'
                                " (error)="onImageError($event)" class="image-analysis" (dblclick)="
                                  showAiImagesFullscreen(aiImages.cbir5Image)
                                " />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div *ngIf="reportError">
                        <p class="fs-5 mb-0">
                          {{ reportError }}
                        </p>
                      </div>
                      <div class="tab-content h-100" *ngIf="fullscreenImageAi">
                        <div class="px-0 position-relative h-100">
                          <button (click)="closeAiImagesFullscreen()" class="fullscreen-button">
                            <i class="fa-solid fa-close fs-1 img-close-icon"></i>
                          </button>
                          <img class="p-0 case-image-item" [src]="fullscreenImageAi" />
                        </div>
                      </div>
                    </div>
                    <!-- Case History Content -->
                    <div id="caseHistory" role="tabpanel" [ngClass]="
                        activeRightTab === '#caseHistory'
                          ? 'tab-pane fade h-100'
                          : 'd-none'
                      ">
                      <div *ngIf="showImageGallery" class="col card-overflow overflow-hidden px-4">
                        <div *ngIf="
                            patientHistoryImages?.length > 0;
                            else noHistory
                          " class="p-3 px-0">
                          <button class="fullscreen-button">
                            <i class="fa-solid fa-expand"></i>
                          </button>
                          <div class="row g-3 ps-1">
                            <div class="col-12" *ngFor="let consultation of patientHistoryImages">
                              <span>
                                {{
                                consultation?.createdDate
                                | date : "dd-MM-yyyy"
                                }}
                              </span>
                              <div class="d-flex overflow-auto pt-3" style="gap: 1rem; padding-bottom: 1rem">
                                <div *ngFor="
                                    let image of consultation?.images;
                                    let i = index
                                  " class="flex-shrink-0" style="
                                    width: calc(25% - 1rem);
                                    max-width: 200px;
                                  ">
                                  <div class="img-square">
                                    <img [src]="image.src" class="img-fluid rounded img-thumbnail border-0 p-0" style="
                                        aspect-ratio: 1 / 1;
                                        object-fit: cover;
                                      " [alt]="image.alt" (dblclick)="
                                        handleDoubleClickForHistoryImage(image)
                                      " />
                                    <span *ngIf="image.isReportImage"
                                      class="badge badge-light-success reported-image">{{
                                      "reportedImage" | translate }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <ng-template #noHistory>
                          <div class="text-start fs-5 py-4 ps-1 pt-2">
                            <p>{{ "patientNoHistory" | translate }}</p>
                          </div>
                        </ng-template>
                      </div>
                      <!-- Full Screen Image For History -->
                      <div id="myTabContent" [ngClass]="
                          showImageGallery ? 'd-none' : 'tab-content h-100'
                        ">
                        <div *ngIf="!showImageGallery" class="h-100">
                          <div class="px-0 position-relative h-100">
                            <button (click)="closeFullscreenImage()" class="fullscreen-button">
                              <i class="fa-solid fa-close fs-1 img-close-icon"></i>
                            </button>
                            <img class="case-image-item p-0" [src]="fullscreenImage.src" />
                            <div class="checkbox-container">
                              <input class="form-check-input" type="checkbox" id="addReportCheckbox"
                                [checked]="fullscreenImage.isReportImage" (click)="
                                  selectImageForReportFromHistory(
                                    fullscreenImage,
                                    $event
                                  )
                                " />
                              <label for="addReportCheckbox">{{
                                "addReport" | translate
                                }}</label>
                              <label *ngIf="fullscreenImage.isSelected"
                                class="badge badge-light-success ai-current-case-image" for="addReportCheckbox">{{ "AI"
                                | translate }}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Chat Content -->
                    <div id="chatWithGp" role="tabpanel" [ngClass]="
                        activeRightTab === '#chatWithGp'
                          ? 'tab-pane fade h-100 px-3 container-flex'
                          : 'd-none'
                      ">
                      <div class="card border border-0 h-100 ps-1">
                        <div class="card-body px-0 pt-0">
                          <div *ngIf="chatList?.length; else noChat" class="chat-card" #chatContainer>
                            <div *ngFor="let chatItem of chatList" class="chat-item my-3 me-3" [ngClass]="{
                                'current-user':
                                  currentUser?.id === chatItem?.createdUserId
                              }">
                              <div class="d-flex align-items-center gap-2 mb-1" [ngClass]="{
                                  'flex-row-reverse':
                                    currentUser?.id !== chatItem?.createdUserId
                                }">
                                <span class="fs-12 text-hour">{{
                                  chatItem?.relativeTime
                                  }}</span>
                                <h5 class="card-title" style="font-size: 12px; margin-top: 8px">
                                  {{
                                  currentUser?.id === chatItem?.createdUserId
                                  ? ("you" | translate)
                                  : chatItem?.createdUserName
                                  }}
                                </h5>
                                <!-- User Avatars -->
                                <img *ngIf="
                                    currentUser?.id === chatItem?.createdUserId;
                                    else otherUser
                                  " [src]="currentUserAvatar" alt="image" class="rounded-circle profile-image-size" />
                                <ng-template #otherUser>
                                  <img [src]="otherUserAvatar" alt="image" class="rounded-circle profile-image-size" />
                                </ng-template>
                              </div>
                              <p class="card-text mt-6 mb-5 fs-4 p-4 rounded-4" style="margin: 0px !important"
                                [class.bg-light-pink]="
                                  currentUser?.id !== chatItem?.createdUserId
                                " [class.bg-light-blue]="
                                  currentUser?.id === chatItem?.createdUserId
                                " [ngClass]="{
                                  'text-end':
                                    currentUser?.id === chatItem?.createdUserId
                                }">
                                {{ chatItem?.message }}
                                <span *ngIf="chatItem?.chatFiles.length">
                                  <i (click)="
                                      downloadChatFile(
                                        chatItem.chatFiles[0]
                                          .chatFileFolderPath,
                                        chatItem.chatFiles[0].chatFileName
                                      )
                                    " class="fa-solid fa-file-arrow-down d-block mt-1"></i>
                                </span>
                              </p>
                              <div class="separator"></div>
                            </div>
                          </div>
                          <ng-template #noChat>
                            <p class="fs-5 py-4 pt-2">
                              {{ "noChatToBeDisplayedHere" | translate }}
                            </p>
                          </ng-template>

                          <!-- Answer input area -->
                          <div
                            class="col d-flex mt-2 justify-content-between align-items-center gap-4 answer-input-area bg-white">
                            <label class="btn btn-link p-0">
                              <div class="d-inline-flex">
                                <!-- Select a file -->
                                <i class="fa-solid fa-paperclip" [ngClass]="
                                    isChatSending
                                      ? 'disable-send-chat-btn'
                                      : 'cursor-pointer'
                                  " (click)="handleFileClick($event)">
                                  <div *ngIf="fileCount > 0" class="file-count">
                                    1
                                  </div>
                                </i>
                              </div>
                              <input type="file" #fileInput style="display: none" (change)="handleFileUpload($event)" />
                            </label>
                            <input type="text" class="form-control border-0 ps-0"
                              style="outline: none; box-shadow: none" [disabled]="
                                currentUser?.role === userRole.OrganizationAdmin
                              " [placeholder]="
                                'gpQuestionPlaceholder' | translate
                              " [(ngModel)]="messageText" (keydown.enter)="
                                !isChatSending && sendChat(consultationId)
                              " />
                            <button (click)="sendChat(consultationId)" class="btn btn-dark btn-sm fw-bold" [ngClass]="
                                isChatSending
                                  ? 'disable-send-chat-btn'
                                  : 'cursor-pointer'
                              ">
                              {{ "send" | translate }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Preview Final Report Modal -->
<div class="modal fade" id="previewFinalReportModal" tabindex="-1" aria-labelledby="previewFinalReportModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-2" id="previewFinalReportModalLabel">
          {{ "previewFinalReport" | translate }}
        </h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body fs-4">
        <div *ngIf="previewReportErrorText; else reportGenerated">
          <p class="fs-4">{{ previewReportErrorText }}</p>
        </div>
        <ng-template #reportGenerated>
          <div id="previewFinalReportContent"></div>
        </ng-template>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          {{ "close" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Conclusion Mail Template Modal -->
<div class="modal fade" id="conclusionMailTemplateModal" tabindex="-1"
  aria-labelledby="conclusionMailTemplateModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg d-flex modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-2" id="conclusionMailTemplateModalLabel">
          {{ "conclusionMailTemplate" | translate }}
        </h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body fs-4">
        <div class="container" *ngIf="notificationMailTemplate">
          <div class="row mb-4">
            <div [ngClass]="
                currentUser?.role === userRole.GeneralPractitioner
                  ? 'col-md-6'
                  : 'col-md-12'
              ">
              <label class="mb-1" for="email">{{ "email" | translate }}</label>
              <input type="text" class="form-control" [(ngModel)]="patientCaseDetails.email"
                (input)="preventForbiddenCharacters($event, 'email')" />
            </div>
            <div *ngIf="currentUser?.role === userRole.GeneralPractitioner" class="col-md-6">
              <label class="mb-1" for="phone">{{ "telNo" | translate }}</label>
              <input type="text" class="form-control" [(ngModel)]="patientCaseDetails.phone" maxlength="15"
                (input)="preventForbiddenCharacters($event, 'tel')" />
            </div>
          </div>
          <label class="mb-1" for="body">{{ "body" | translate }}</label>
          <textarea [(ngModel)]="notificationMailTemplate.body" class="form-control" style="height: 75vh" name="body"
            id="body">
            {{ notificationMailTemplate.body }}
          </textarea>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" (click)="sendReport()" data-bs-dismiss="modal" class="btn btn-dark ms-3"
          [disabled]="isSubmitButtonDisable()">
          {{ "sendReport" | translate }}
        </button>
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          {{ "close" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>